<template>
	<svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M21.0607 0.43934C21.6464 1.02513 21.6464 1.97487 21.0607 2.56066L9.06066 14.5607C8.47487 15.1464 7.52513 15.1464 6.93934 14.5607L0.93934 8.56066C0.353553 7.97487 0.353553 7.02513 0.93934 6.43934C1.52513 5.85355 2.47487 5.85355 3.06066 6.43934L8 11.3787L18.9393 0.43934C19.5251 -0.146447 20.4749 -0.146447 21.0607 0.43934Z" fill="currentColor" />
	</svg>
</template>
